var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3173 9.0481L9.75733 4.7681C4.00733 1.8881 1.64733 4.2481 4.52733 9.9981L5.39733 11.7381C5.64733 12.2481 5.64733 12.8381 5.39733 13.3481L4.52733 15.0781C1.64733 20.8281 3.99733 23.1881 9.75733 20.3081L18.3173 16.0281C22.1573 14.1081 22.1573 10.9681 18.3173 9.0481ZM15.0873 13.2881H9.68733C9.27733 13.2881 8.93733 12.9481 8.93733 12.5381C8.93733 12.1281 9.27733 11.7881 9.68733 11.7881H15.0873C15.4973 11.7881 15.8373 12.1281 15.8373 12.5381C15.8373 12.9481 15.4973 13.2881 15.0873 13.2881Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c1d5b6b035d406bfb486fc3684029f7a.svg";
export { ForwardRef as ReactComponent };